import { DeliveryAddress } from '@/components/Buyer/BuyerProfile/DeliveryAddress/DeliveryAddressUi';
import { BuyerAddressesResponse } from '@/data/api/model/buyers/BuyersDto';

export function getBuyerAddressesResponseToBuyerAddressesUi(
  input: BuyerAddressesResponse
): DeliveryAddress[] {
  return (
    input?.data?.map((addressResponse, index) => {
      const addressTitle = addressResponse?.tag?.trim()
        ? addressResponse.tag
        : `Dirección ${index + 1}`;

      let addressSubtitle = `${addressResponse.street}, ${addressResponse.exterior_number} ${addressResponse.zip_code}, ${addressResponse.colony}`;
      if (addressResponse.interior_number)
        addressSubtitle = `${addressResponse.street} ${addressResponse.exterior_number} Int. ${addressResponse.interior_number}, ${addressResponse.colony}, ${addressResponse.zip_code}`;

      return {
        id: addressResponse.address_id ?? '',
        title: addressTitle,
        subtitle: addressSubtitle,
        isFavorite: Boolean(addressResponse.default),
      };
    }) ?? []
  );
}
